import { AppConfig } from '@pulpo/app-config';

export const environment: AppConfig = {
  production: false,
  name: 'dev',
  apiUrl: 'https://dev.kube.pulpo.tech/',
  adminEmail: 'tech@elpulpo.io',
  itemsPerPage: 20,
  schedulerApiUrl: 'http://localhost:4015',
  loginRoute: '/login',
  ribbonLabel: 'development',
};
